function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { throttle } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
export function useTheme() {
  var isWatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var htmlDomRef = useRef(document.querySelector("html"));
  var _useState = useState(function () {
      if (isWatch) {
        var htmlDom = document.querySelector("html");
        return {
          theme: htmlDom.className.includes("dark") ? "dark" : "light",
          ticker: htmlDom.className.includes("ticker-reversed") ? true : false
        };
      }
      return null;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setThemeDispatch = _useState2[1];
  var setTheme = useCallback(function (params) {
    var _htmlDomRef$current;
    var list = (_htmlDomRef$current = htmlDomRef.current) === null || _htmlDomRef$current === void 0 ? void 0 : _htmlDomRef$current.classList;
    if (list) {
      list.add("theme-".concat(params.theme));
      list.add("".concat(params.theme));
      if (params.theme === "dark") {
        list.remove("light");
        list.remove("theme-light");
      } else {
        list.remove("dark");
        list.remove("theme-dark");
      }
      if (params.ticker) {
        list.add("ticker-reversed");
        list.remove("ticker");
      } else {
        list.remove("ticker-reversed");
        list.add("ticker");
      }
    }
  }, []);
  useEffect(function () {
    if (isWatch) {
      var htmlDom = document.querySelector("html");
      var cb = throttle(function callback(mutationList, observer) {
        if (mutationList.some(function (mutation) {
          return mutation.type === "attributes" && mutation.attributeName === "class";
        })) {
          setThemeDispatch(function () {
            return {
              theme: htmlDom.className.includes("dark") ? "dark" : "light",
              ticker: htmlDom.className.includes("ticker-reversed") ? true : false
            };
          });
        }
      });
      var observer = new MutationObserver(cb);
      observer.observe(htmlDom, {
        attributes: true
      });
      return function () {
        observer.disconnect();
      };
    }
  }, [isWatch]);
  // @ts-ignore
  return [theme, setTheme];
}